import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AssetFile } from '@brafton/assets-api';
import { ProjectHelper } from 'src/app/core/utils/project.helper';

@Component({
  selector: 'content-image',
  templateUrl: './content-image.component.html',
  styleUrls: ['./content-image.component.scss'],
  host: { class: 'content-image' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContentImageComponent implements OnInit {
  @Input() project?: any;
  @Input() size = 120;
  @Input() details = true;
  @Input() compressed = false;

  assetFile!: AssetFile;

  @Output() loaded = new EventEmitter<boolean>();
  @Output() errored = new EventEmitter<boolean>();
  @HostBinding('class.compressed') get compressedChecker() {
    return this.compressed == true;
  }

  constructor(
    private router: Router,
    private projectHelper: ProjectHelper,
  ) {}

  ngOnInit() {
    if (this.project && this.project?.defaultAsset) {
      this.assetFile = this.project?.defaultAsset?.assetFiles[0];
    }
  }

  openLink() {
    if (!this.project) return;

    const route = this.projectHelper.findProjectRoute(this.project);

    this.router.navigate([route]);
  }
}
